<template>
  <!-- z-index как у v-dialog, см. UiDialog. Оформление окна рисует содержимое, поэтому bare. -->
  <Dialog ref="dialog" :model-value="props.modelValue" @update:model-value="val => emits('update:model-value', val)"
          :width="width" :mobile-breakpoint="mobileBreakpoint" :persistent="props.persistent" :z-index="2400" bare>
    <slot></slot>
  </Dialog>
</template>

<script setup lang="ts">
import {computed, useTemplateRef} from 'vue';
import {Dialog} from '@ismet/vue-ui-kit';

interface IProps {
  modelValue: boolean;
  /**
   * Не используется: Dialog из ui-kit не перехватывает фокус за своими пределами,
   * поэтому виджеты вне окна (оплата KT Pay) и так получают ввод. Оставлен для совместимости.
   */
  retainFocus?: boolean;
  width?: number | string;
  persistent?: boolean;
}

interface IEmits {
  (e: 'update:model-value', val: boolean): void;
}

/** Последняя ширина экрана, на которой окно без своей ширины становится шторкой (vuetify xs) */
const XS_MAX_WIDTH = 599;

const props = defineProps<IProps>();
const emits = defineEmits<IEmits>();

const dialog = useTemplateRef('dialog');

const isFitContent = computed(() => props.width === undefined || props.width === 'fit-content');

const width = computed(() => isFitContent.value ? 'fit-content' : props.width);

// Окно с заданной шириной становится шторкой само, когда не помещается в экран; без ширины — на xs
const mobileBreakpoint = computed(() => isFitContent.value ? XS_MAX_WIDTH : -1);

const isBottom = computed(() => dialog.value?.isBottom ?? false);

defineExpose({
  isBottom,
});
</script>
